/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConsensusEvent,
    ConsensusEventFromJSON,
    ConsensusEventFromJSONTyped,
    ConsensusEventToJSON,
    ConsensusEventListAllOf,
    ConsensusEventListAllOfFromJSON,
    ConsensusEventListAllOfFromJSONTyped,
    ConsensusEventListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConsensusEventList
 */
export interface ConsensusEventList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof ConsensusEventList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof ConsensusEventList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<ConsensusEvent>}
     * @memberof ConsensusEventList
     */
    events: Array<ConsensusEvent>;
}

export function ConsensusEventListFromJSON(json: any): ConsensusEventList {
    return ConsensusEventListFromJSONTyped(json, false);
}

export function ConsensusEventListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsensusEventList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'events': ((json['events'] as Array<any>).map(ConsensusEventFromJSON)),
    };
}

export function ConsensusEventListToJSON(value?: ConsensusEventList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'events': ((value.events as Array<any>).map(ConsensusEventToJSON)),
    };
}


